/**
 * Created by jv on 2019-09-09 (10:50).
 */
const log = require("Sources/utils/logger")();
import Shared from "Sources/shared";
import utils from "Sources/utils/utils";
import LanguageManager from "Sources/services/language-manager";
import GameSessionController from "Sources/controllers/game-session-controller";
import GamePageController from "Sources/controllers/game-page-controller";
import GameSessionMessage from "Sources/models/game-session-message";
import CreditsDialog from "Sources/components/credits-dialog";

const headerHtml = require("Views/partials/game/shared/header.html");
const GameViews = require.context("Sources/components/game/views", false, /\.js$/);

// Styles
require("Styles/pages/game.scss");

$(function () {
  Shared.shouldSetUpCreditsDialog = false;

  Shared.init();
  SeriousGame.init();
});

let SeriousGame = {};

((SeriousGame) => {
  let gamePageController;
  let gameSessionController;

  let $header;

  let creditsDialog;

  let joinSessionView;
  let introductionView;
  let quizView;
  let businessModelView;
  let reconnectView;

  let currentGameView;

  let gameSessionId = null;
  let teamName = null;

  let gameSession;
  let caseWrapper;
  let roundOverview;
  let endGameData;

  let pathSessionId = null;

  let canReconnect = false;
  let isWaitingToReconnect = false;
  let reconnectAttempts = 0;

  // Will be set to false when client gets 'shouldClose' param from server, otherwise true
  let shouldReconnect = true;

  SeriousGame.init = function () {
    let pathSection2 = utils.getPathSection(2);

    if (pathSection2 === "sessionid") {
      pathSessionId = utils.getPathSection(3);
    }

    let websocketProtocol = window.location.protocol.includes("https") ? "wss:" : "ws:";

    gameSessionController = new GameSessionController({
      baseUrl: `${websocketProtocol}//${window.location.host}/services/1.0/realtime/gamesession/`
    });

    gameSessionController.addEventListener("session-opened", onSessionOpened);
    gameSessionController.addEventListener("session-closed", onSessionClosed);
    gameSessionController.addEventListener("session-error", onSessionError);
    gameSessionController.addEventListener("session-message", onSessionMessage);

    setUpHeader();
    setUpViews();
    setGamePageController();

    renderCreditsDialog();
    setUpEventListeners();
  };

  function setUpHeader() {
    $header = $(headerHtml);
    $("#game-view-header").append($header);
    LanguageManager.applyLocale($header);
  }

  function setUpViews() {
    joinSessionView = createGameView("session-join", {sessionId: pathSessionId});
    introductionView = createGameView("introduction");
    quizView = createGameView("quiz");
    businessModelView = createGameView("business-model");
    reconnectView = createGameView("reconnect");

    joinSessionView.onJoinSession = function (element) {
      gameSessionId = this.getFormSessionId();
      teamName = this.getFormTeamName();

      if (utils.isNotNull(teamName)) {
        teamName = teamName.trim();
      }

      joinSession(gameSessionId, teamName);
    };

    introductionView.onIntroductionCompleted = function (skipped) {
      log.info("Introduction complete (skipped? %s)", skipped);
      introductionView.setLoadingState(true);
      let message = GameSessionMessage.createRequest("introductionCompleted", null, {skipped});
      gameSessionController.sendMessage(message);
    };

    quizView.onQuestionAnswered = function (index, isCorrect) {
      log.info("Sending answer request to server: Question [%d] answered - correct ? %s", index, isCorrect);

      let data = {
        index,
        isCorrect
      };

      let message = GameSessionMessage.createRequest("quizQuestionAnswered", null, data);
      gameSessionController.sendMessage(message);
    };

    businessModelView.onRenderCompleted = function () {
      if (roundOverview.currentRoundData.roundIndex === 1 && utils.isNull(roundOverview.currentRoundData.closed)) {
        this.showTutorialDialog();
      }
    };

    businessModelView.onInvestmentAdded = function (investment, extraProductId) {
      log.info("Sending purchase request to server for investment [%s]", investment.type);

      let data = {
        investmentKey: investment.key,
        extraProductKey: extraProductId
      };

      let message = GameSessionMessage.createRequest("businessModelInvestment", null, data);
      gameSessionController.sendMessage(message);
    };

    businessModelView.onTeamClosedRound = function () {
      log.info("Sending close round request to server");

      let message = GameSessionMessage.createRequest("businessModelRoundClosed", null, null);
      gameSessionController.sendMessage(message);
    };

    businessModelView.onTeamRequestedLoan = function () {
      log.info("Sending close round request to server");

      let message = GameSessionMessage.createRequest("requestLoan", null, null);
      gameSessionController.sendMessage(message);
    };

    businessModelView.onTeamOverviewChanged = function (teamEndData) {
      log.info("Changing team endgame overview to [%s]", teamEndData.teamName);
      SeriousGame.setPageTitle(teamEndData.teamName);
    };

    businessModelView.onTeamOverviewClosed = function () {
      log.info("Closed team endgame overview, changing title");
      SeriousGame.setPageTitle(LanguageManager.getValueForKey("serious_game.page_title.score"));
    };

    reconnectView.onCancelReconnect = function () {
      joinSessionView.setJoinButtonLoading(false);
      joinSessionView.showForm();

      gamePageController.changePage(joinSessionView);
    };
  }

  function setGamePageController() {
    let gameViews = [];

    gameViews.push(joinSessionView);
    gameViews.push(introductionView);
    gameViews.push(quizView);
    gameViews.push(businessModelView);
    gameViews.push(reconnectView);

    gamePageController = new GamePageController({
      basePath: "/game",
      gameViews,
      defaultView: joinSessionView,
      initialPage: "/game/session-join",
      onBeforePageChange,
      onContentShow
    });

    gamePageController.init();
  }

  function renderCreditsDialog() {
    if (utils.isNotNull(creditsDialog)) {
      creditsDialog.destroy();
    }

    creditsDialog = new CreditsDialog({
      onCancel: () => {
        if (currentGameView.key === "business-model") {
          businessModelView.setActionBarLayer(false);
        }

        currentGameView.removeBackdrop();
        creditsDialog.hide();
      }
    });

    creditsDialog.create();
  }

  function createGameView(key, options) {
    let fileKey = `./${key}.js`;
    if (GameViews.keys().includes(fileKey)) {
      let GameViewClass = GameViews(fileKey);

      return new GameViewClass({
        key,
        container: "#game-view-wrapper",
        gameSessionController,
        ...options
      });
    } else {
      log.error("Couldn't find game view [%s]", key);
    }
  }

  function onBeforePageChange(gameView) {
    log.info("On before page change - game view: %o", gameView);

    // Boolean determines if page change is allowed or not
    return true;
  }

  function onContentShow(gameView) {
    log.info("On content show - game view: %o", gameView);

    if (utils.isNotNull(gameView)) {
      currentGameView = gameView;

      if (gameView.key === joinSessionView.key) {
        SeriousGame.setPageTitle(LanguageManager.getValueForKey("serious_game.page_title.default"));
        SeriousGame.hideRoundsBreadcrumb();
      } else if (gameView.key === introductionView.key) {
        SeriousGame.setPageTitle(LanguageManager.getValueForKey("serious_game.page_title.introduction"));
        SeriousGame.hideRoundsBreadcrumb();
      } else if (gameView.key === quizView.key) {
        let teamName = gameSession && gameSession.team ? gameSession.team.name : LanguageManager.getValueForKey("serious_game.page_title.default");
        SeriousGame.setPageTitle(teamName);
        SeriousGame.showRoundsBreadcrumb("quiz");
        SeriousGame.setRoundBreadcrumbActive(roundOverview.commonDataSelf.quizResult.currentQuizQuestion);
        quizView.setCurrentQuestion(roundOverview.commonDataSelf.quizResult.currentQuizQuestion);
      } else if (gameView.key === businessModelView.key) {
        let teamName = gameSession && gameSession.team ? gameSession.team.name : LanguageManager.getValueForKey("serious_game.page_title.default");
        SeriousGame.setPageTitle(teamName);
        SeriousGame.showRoundsBreadcrumb();
        // Note: round index goes from 0 to 5 (0 = quiz) so subtract 1 to only match the actual "game" rounds to the breadcrumb indexes
        SeriousGame.setRoundBreadcrumbActive(roundOverview.currentRoundData.roundIndex - 1);
      } else {
        SeriousGame.setPageTitle(LanguageManager.getValueForKey("serious_game.page_title.default"));
        SeriousGame.hideRoundsBreadcrumb();
      }

      gameView.show();
    }
  }

  SeriousGame.setPageTitle = function (title) {
    $("#page-title").text(title);
  };

  SeriousGame.showRoundsBreadcrumb = function (labelType) {
    let $roundsBreadcrumb = $("#rounds-breadcrumb");

    let labelKey = labelType === "quiz" ? "serious_game.rounds_breadcrumb.labels.quiz" : "serious_game.rounds_breadcrumb.labels.business_model";

    $roundsBreadcrumb.find(".breadcrumb__label").text(LanguageManager.getValueForKey(labelKey));
    $roundsBreadcrumb.show();
  };

  SeriousGame.hideRoundsBreadcrumb = function () {
    $("#rounds-breadcrumb").hide();
  };

  SeriousGame.setRoundBreadcrumbActive = function (round) {
    $("#rounds-breadcrumb").find(".round-breadcrumb__item").each(function (index, el) {
      let $el = $(el).removeClass("active");

      if (round === index) {
        $el.addClass("active");
      }
    });
  };

  function joinSession(sessionId, teamName) {
    gameSessionController.sessionId = sessionId;
    gameSessionController.teamName = teamName;
    gameSessionController.init();
    gameSessionController.connect();
  }

  function onSessionOpened(e) {
    log.debug("Session opened - %o", e);

    canReconnect = true;
    shouldReconnect = true;

    joinSessionView.setJoinButtonLoading(false);
    joinSessionView.showLoadingState();
  }

  function onSessionClosed(e) {
    log.debug("Session closed - %o", e);

    if (shouldReconnect) {
      reconnect({retryCount: 3});
    } else {
      joinSessionView.setJoinButtonLoading(false);
      joinSessionView.showForm();
      gamePageController.changePage(joinSessionView);
    }
  }

  function onSessionError(e) {
    log.debug("Session error: %o", e);
    reconnect({retryCount: 3});
  }

  function onSessionMessage(e) {
    log.debug("Session message: %o", e);
    handleMessage(e);
  }

  function reconnect(options) {
    if (!shouldReconnect) return;
    if (utils.isNull(options)) options = {};

    if (utils.isNull(gameSessionController) || utils.isNull(gameSessionController.sessionId) || utils.isNull(gameSessionController.teamName)) {
      gamePageController.changePage(joinSessionView);
      return;
    }

    let retryCount = options.retryCount;
    let timeBetweenAttempts = options.timeBetweenAttempts || 3 * 1000;
    shouldReconnect = false;

    if (canReconnect) {
      // Reconnect can only happen when you were connected before, meaning 'canReconnect' is only set to true once connected
      canReconnect = false;
      reconnectAttempts = 0;

      shouldReconnect = true;

      reconnectView.clearReconnectResult();
      gamePageController.changePage(reconnectView);
    } else if (!options.skipTimeout && !isWaitingToReconnect) {
      log.info("Waiting for %dms before attempting another reconnect", timeBetweenAttempts);

      isWaitingToReconnect = true;

      setTimeout(() => {
        isWaitingToReconnect = false;
        reconnect({retryCount, skipTimeout: true, force: true});
      }, timeBetweenAttempts);

      return;
    }

    // Prevents that more than 1 reconnect attempt is running at the same time (canReconnect is immediately set to 'false' and maximum 1 reconnect timeout can run at any given time)
    if (shouldReconnect || options.force) {
      reconnectAttempts++;

      log.info("Trying to reconnect to game session '%s' for team '%s'\nReconnect attempts: %d / %d", gameSessionId, teamName, reconnectAttempts, retryCount);

      if (utils.isNumber(retryCount) && reconnectAttempts <= retryCount) {
        gameSessionController.connect();
      } else {
        // Show message
        reconnectView.setReconnectFailed();

        setTimeout(() => {
          joinSessionView.setJoinButtonLoading(false);
          joinSessionView.showForm();

          gamePageController.changePage(joinSessionView);
        }, 3000);
      }
    }
  }

  function handleMessage(event) {
    if (utils.isNotNull(event) && utils.isNotNull(event.data)) {
      let message = utils.parseJSON(event.data, true);

      log.info("Message data - %o", message);

      if (utils.isNotNull(message)) {
        switch (message.type) {
          case "request":
            handleMessageRequest(message);
            break;
          case "response":
            handleMessageResponse(message);
            break;
          case "error":
            handleMessageError(message);
            break;
        }
      }
    }
  }

  function handleMessageRequest(message) {
    if (utils.isNotNull(message)) {
      switch (message.service) {
        case "closeConnection":
          handleCloseConnectionRequest(message);
          break;

        case "gameSessionJoined":
          // This session successfully joined the game session
          handleSessionJoined(message);
          break;
        case "teamJoined":
          // A team (different from this team) joined the game session
          handleTeamJoined(message);
          break;
        case "teamRemoved":
          // A team has been removed from the game session
          handleTeamRemoved(message);
          break;
        case "startGame":
          // Teacher started the game session
          handleSessionStarted(message);
          break;
        case "allTeamsFinishedQuiz":
          // All teams finished the quiz --> show result screen
          handleQuizFinished(message);
          break;
        case "startNextRound":
          handleRoundStarted(message);
          break;
        // Message when another team has ended their round so we can update information
        case "teamEndedRound":
        case "teamEndedRoundByTeacher":
          handleTeamEndedRound(message);
          break;
        // Message when teacher has closed the round instead of the team itself
        case "teacherEndedRound":
          handleTeacherEndedRound(message);
          break;

        case "reloadedData":
          handleReloadedData(message);
          break;
        case "gameFinished":
          handleGameFinished(message);
          break;
      }
    }
  }

  function handleMessageResponse(message) {
    if (utils.isNotNull(message)) {
      switch (message.service) {
        case "introductionEndRegistered":
          handleIntroductionEndRegistered(message);
          break;
        case "answerRegistered":
          handleAnswerRegistered(message);
          break;
        case "investmentRegistered":
          handleInvestmentRegistered(message);
          break;
        case "roundEndRegistered":
          handleRoundEndRegistered(message);
          break;
        case "loanRegistered":
          handleLoanRegistered(message);
          break;
      }
    }
  }

  function handleMessageError(message) {
    if (utils.isNotNull(message)) {
      if (utils.isNotNull(message.params)) {
        let messageKey = `errors.websocket.${message.error}.message`;
        let messageText = LanguageManager.getValueForKey(messageKey);

        if (messageKey !== messageText) {
          if (utils.isNotNull(currentGameView) && currentGameView.key === "session-join") {
            // Show error message in 'session-join' form
            joinSessionView.setFormError(messageText);
            joinSessionView.setJoinButtonLoading(false);
            joinSessionView.showForm();
          } else {
            // Show error message in dialog
          }
        }

        if (message.params["shouldClose"] === "true") {
          shouldReconnect = false;
          gameSessionController.disconnect();
        } else {
          reconnect({retryCount: 3});
        }
      }
    }
  }

  function goToCurrentView() {
    if (gameSession.status === "created") {
      gamePageController.changePage(joinSessionView);
      joinSessionView.showLoadingState();
    } else if (gameSession.status === "playing") {
      if (utils.isNotNull(roundOverview.currentRoundData)) {
        if (roundOverview.currentRoundData.roundIndex === 0) {
          if (roundOverview.commonDataSelf.quizResult.currentQuizQuestion === 0) {
            gamePageController.changePage(introductionView);
          } else {
            gamePageController.changePage(quizView);

            let quizFinished = true;
            for (let i = 0; i < roundOverview.commonTeamData.length; i++) {
              if (utils.isNull(roundOverview.commonTeamData[i].state.currentRoundClosed)) {
                quizFinished = false;
                break;
              }
            }

            if (quizFinished) {
              quizView.showScoreScreen({
                currentTeam: gameSession.team,
                roundOverview,
                roundIndex: 0
              });

              SeriousGame.setPageTitle(LanguageManager.getValueForKey("serious_game.page_title.score"));
            } else if (utils.isNotNull(roundOverview.currentRoundData.closed)) {
              quizView.showWaitingScreen();
            } else {
              quizView.hideScoreScreen();
            }
          }
        } else {
          let wasAlreadyOnBusinessModel = currentGameView.key === businessModelView.key;

          if (!wasAlreadyOnBusinessModel) {
            gamePageController.changePage(businessModelView);
          }

          if (utils.isNotNull(roundOverview.currentRoundData.closed)) {
            SeriousGame.setPageTitle(LanguageManager.getValueForKey("serious_game.page_title.score"));
            businessModelView.showScoreScreen({
              currentTeam: gameSession.team,
              roundOverview,
              asOverlay: false,
              keepVisible: true
            });
          } else {
            if (wasAlreadyOnBusinessModel) {
              // Note: quickfix ... need to go back to business model view if we are on 'waiting room score screen', otherwise we are stuck and have to refresh
              if (businessModelView.scoreScreen.isOpen() && businessModelView.$scoreScreenContainer.hasClass("bm__background-filled")) {
                businessModelView.showBusinessModel(true, true);
              }
            } else {
              businessModelView.showBusinessModel(true, true);
            }
          }
        }
      } else {
        gamePageController.changePage(introductionView);
      }
    } else if (gameSession.status === "finished") {
      gamePageController.changePage(businessModelView);
      businessModelView.showEndGameView(endGameData);
    }
  }

  function extractInitialData(message) {
    caseWrapper = message.data.caseWrapper;
    gameSession = message.data.gameSession;
    endGameData = message.data.endGameData;

    extractRoundOverview(message.data.roundOverview);
  }

  function extractRoundOverview(data) {
    roundOverview = data;
    extractCommonDataSelf(roundOverview.commonTeamData);
  }

  function extractCommonDataSelf(commonTeamData) {
    roundOverview.commonDataSelf = null;

    if (utils.isNotNull(commonTeamData)) {
      for (let i = 0; i < commonTeamData.length; i++) {
        if (commonTeamData[i].teamName === gameSession.team.name) {
          roundOverview.commonDataSelf = commonTeamData[i];
          break;
        }
      }
    }
  }

  function extractQuizResult(message) {
    roundOverview.commonDataSelf.quizResult = message.data;
  }

  function reloadData(message) {
    extractInitialData(message);

    businessModelView.caseWrapper = caseWrapper;
    businessModelView.gameSession = gameSession;
    businessModelView.team = gameSession.team;
    businessModelView.setRoundOverview(roundOverview);

    introductionView.videoLink = caseWrapper.caseObj.movie;
    quizView.gameSession = gameSession;
    quizView.questions = caseWrapper.questions;
    quizView.currentQuestion = roundOverview.commonDataSelf.quizResult.currentQuizQuestion;

    // TODO validate data??
    goToCurrentView();
  }

  function handleCloseConnectionRequest(message) {
    log.info("Server requested to close connection for game session [%s] and team [%s]", gameSessionId, teamName);
    shouldReconnect = false;
    gameSessionController.disconnect();
  }

  function handleSessionJoined(message) {
    log.info("Successfully joined game session [%s] with team name [%s]\nGameSession: %o\nCase: %o", gameSessionId, teamName, gameSession, caseWrapper);
    reloadData(message);
  }

  function handleTeamJoined(message) {
    let newTeam = message.data.teamName;

    log.info("Team [%s] joined game session (session count: %d)", newTeam, message.data.sessionCount);

    if (utils.isNull(gameSession.teamList)) gameSession.teamList = [];

    if (!gameSession.teamList.includes(newTeam)) {
      gameSession.teamList.push(newTeam);
    }
  }

  function handleTeamRemoved(message) {
    let removedTeam = message.data.teamName;

    log.info("Team [%s] removed from game session", removedTeam);

    if (utils.isNotNull(gameSession.teamList) && gameSession.teamList.includes(removedTeam)) {
      for (let i = 0; i < gameSession.teamList.length; i++) {
        if (gameSession.teamList[i] === removedTeam) {
          gameSession.teamList.splice(i, 1);
          break;
        }
      }

      if (utils.isNotNull(quizView)) {
        quizView.updateTeamList(gameSession.teamList);
      }

      if (utils.isNotNull(businessModelView)) {
        businessModelView.updateTeamList(gameSession.teamList);
      }
    }
  }

  function handleSessionStarted(message) {
    log.info("Session started - going to introduction");

    extractInitialData(message);

    quizView.currentQuestion = roundOverview.commonDataSelf.quizResult.currentQuizQuestion;

    gamePageController.changePage(introductionView);
  }

  function handleQuizFinished(message) {
    log.info("All teams finished the quiz - %o", message);

    roundOverview.commonTeamData = message.data.commonTeamData;
    extractCommonDataSelf(roundOverview.commonTeamData);

    quizView.showScoreScreen({
      currentTeam: gameSession.team,
      roundOverview,
      roundIndex: 0 // quiz
    });
    SeriousGame.setPageTitle(LanguageManager.getValueForKey("serious_game.page_title.score"));
  }

  function handleRoundStarted(message) {
    log.info("Teacher started the next round");

    extractRoundOverview(message.data);

    let currentRoundData = roundOverview.currentRoundData;
    SeriousGame.setPageTitle(gameSession.team.name);

    if (gameSession.team.roundData.hasOwnProperty(currentRoundData.roundIndex)) {
      gameSession.team.roundData[currentRoundData.roundIndex] = currentRoundData;

      if (currentGameView.key !== businessModelView.key) {
        gamePageController.changePage(businessModelView);
      }

      SeriousGame.setRoundBreadcrumbActive(roundOverview.currentRoundData.roundIndex - 1);
      businessModelView.setRoundOverview(roundOverview);
      businessModelView.showBusinessModel(true);

      let subsidyResult = utils.isNotNull(message.params) ? message.params.subsidyResult : null;
      showStartRoundDialogs(subsidyResult);
    } else {
      log.error("Unable to find round data for round [%d]", currentRoundData.roundIndex);
    }
  }

  function showStartRoundDialogs(subsidyResult) {
    // Show:
    //    event dialog --> subsidy dialog --> loan dialog (if one is not needed, skip to the next one)

    let showLoanDialog;
    let showSubsidyDialog;
    let showEventDialog;

    if (roundOverview.currentRoundData.canLoan && roundOverview.currentRoundData.loaned > 0) {
      if (roundOverview.currentRoundData.loaned > 0) {
        showLoanDialog = () => businessModelView.showLoanDialog("auto-loan", true, businessModelView.pulsateLoanButton.bind(businessModelView));
      } else {
        showLoanDialog = () => businessModelView.showLoanDialog("optional-loan", true, businessModelView.pulsateLoanButton.bind(businessModelView));
      }
    }

    if (utils.isNotNull(subsidyResult)) {
      showSubsidyDialog = () => {
        businessModelView.showInvestmentExtra("subsidy", {
          subsidyApproved: subsidyResult === "approved"
        }, true, showLoanDialog);
      };
    }

    if (utils.isNotNull(roundOverview.currentEvent)) {
      showEventDialog = () => {
        businessModelView.pulsateEventButton();
        businessModelView.showEventDialog(true, showSubsidyDialog || showLoanDialog);
      };
    }

    if (utils.isNotNull(showEventDialog)) showEventDialog();
    else if (utils.isNotNull(showSubsidyDialog)) showSubsidyDialog();
    else if (utils.isNotNull(showLoanDialog)) showLoanDialog();
  }

  function handleIntroductionEndRegistered(message) {
    extractRoundOverview(message.data);

    introductionView.setLoadingState(false);

    gamePageController.changePage(quizView);
    quizView.setCurrentQuestion(roundOverview.commonDataSelf.quizResult.currentQuizQuestion);
    SeriousGame.setRoundBreadcrumbActive(roundOverview.commonDataSelf.quizResult.currentQuizQuestion);

    if (roundOverview.commonDataSelf.quizResult.quizCompleted) {
      if (roundOverview.commonDataSelf.quizResult.allTeamsDone) {
        quizView.showScoreScreen({
          currentTeam: gameSession.team,
          roundOverview,
          roundIndex: 0 // quiz
        });
      } else {
        quizView.showWaitingScreen();
      }
    }
  }

  function handleAnswerRegistered(message) {
    log.info("Answer registered successfully");

    extractQuizResult(message);

    quizView.setCurrentQuestion(roundOverview.commonDataSelf.quizResult.currentQuizQuestion);
    SeriousGame.setRoundBreadcrumbActive(roundOverview.commonDataSelf.quizResult.currentQuizQuestion);

    if (roundOverview.commonDataSelf.quizResult.quizCompleted) {
      quizView.showWaitingScreen();
    }
  }

  function handleInvestmentRegistered(message) {
    log.info("Investment purchase registered successfully");

    extractRoundOverview(message.data.roundOverview);

    gameSession.team.roundData[roundOverview.currentRoundData.roundIndex] = roundOverview.currentRoundData;

    if (currentGameView.key !== businessModelView.key) {
      gamePageController.changePage(businessModelView);
    }

    businessModelView.gameSession = gameSession;
    businessModelView.team = gameSession.team;
    businessModelView.setRoundOverview(roundOverview);
    // Also hides investment dialog ( + set btn loading to false) and investment slider
    businessModelView.showBusinessModel(true, true);

    if (utils.isNotNull(message.data.circularBonus)) {
      businessModelView.showGameBonusDialog(message.data.circularBonus.type, message.data.circularBonus.value);
    }
  }

  function handleRoundEndRegistered(message) {
    log.info("Round end registered successfully");

    extractRoundOverview(message.data);

    SeriousGame.setPageTitle(LanguageManager.getValueForKey("serious_game.page_title.score"));
    businessModelView.setRoundOverview(roundOverview);
    businessModelView.showScoreScreen({
      asOverlay: false
    });
  }

  function handleLoanRegistered(message) {
    log.info("Loan was registered successfully");

    extractRoundOverview(message.data);
    businessModelView.setRoundOverview(roundOverview);
    businessModelView.showBusinessModel(true, true);
  }

  function handleTeamEndedRound(message) {
    log.info("Team [%s] ended its current round", message.data.teamName);

    roundOverview.commonTeamData = message.data.commonTeamData;
    extractCommonDataSelf(roundOverview.commonTeamData);
    businessModelView.setRoundOverview(roundOverview);
  }

  function handleTeacherEndedRound(message) {
    // Same as when team would end the round, but instead it's the teacher who forced the team to close the round
    log.info("Round end registered successfully");

    extractRoundOverview(message.data);

    SeriousGame.setPageTitle(LanguageManager.getValueForKey("serious_game.page_title.score"));
    businessModelView.setRoundOverview(roundOverview);
    businessModelView.showScoreScreen({
      asOverlay: false
    });
  }

  function handleReloadedData(message) {
    log.info("Data has been reloaded for game session [%s]\nGameSession: %o\nCase: %o", gameSessionId, gameSession, caseWrapper);
    reloadData(message);
  }

  function handleGameFinished(message) {
    log.info("All teams have closed the last round - game is finished");
    endGameData = message.data;
    businessModelView.showEndGameView(endGameData);
  }

  function setUpEventListeners() {
    $("#header-circonopoly-brand").off("click").on("click", (e) => {
      e.preventDefault();
      e.stopPropagation();

      if (utils.isNotNull(creditsDialog)) {
        if (currentGameView.key === "business-model") {
          businessModelView.showBusinessModel(true, true);
          businessModelView.setActionBarLayer(true);
        }

        currentGameView.showBackdrop();
        creditsDialog.show();
      }
    });
  }

})(SeriousGame);



// WEBPACK FOOTER //
// ./app/js/entries/game.js